import { NgModule } from '@angular/core';
import { ScreenSizeDirective } from './screen-size.directive';

@NgModule({
  declarations: [ScreenSizeDirective],
  exports: [ScreenSizeDirective],
})
export class ScreenSizeModule {}
